export default "/images/vendor/flag-icons/flags/1x1/ge.svg?6c56f6ba97744ba8bc1933c7704014e8";